import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  pricingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  formLabel: {
    fontSize: '14px',
  },
  formLabelContainer: {
    paddingTop: theme.spacing(3),
  },
  updateRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'top',
    padding: theme.spacing(1, 0),
  },
  textField: {
    width: '211px',
    marginRight: theme.spacing(3),
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  closeIconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(-2.5, 0, -3, 2.812),
  },
  closeIcon: {
    '&.MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      color: theme.palette.icon.main,
    },
  },
  labelAndInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  infoIcon: {
    color: theme.palette.icon.main,
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  tooltipInfo: {
    margin: theme.spacing(3.5, 0, 0, -1),
  },
  dateField: {
    '& .MuiInputLabel-root': {
      marginTop: theme.spacing(-0.5),
    },
  },
  installmentContainer: {
    margin: theme.spacing(2.25, 0, 0, 4.25),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  resaleInstallmentContainer: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  checkbox: {
    '&.MuiCheckbox-root': {
      color: theme.palette.primary.light,
    },
    '&.Mui-checked': {
      color: theme.palette.labraCheckbox.main,
    },
  },
}))
